import React, { useState, useEffect } from "react";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import {
  Button,
  Paper,
  Popover,
  Tooltip,
  withStyles,
  FormLabel,
  TextField,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { ReactComponent as AddQuestionIcon } from "../../../images/examimage/addquestion.svg";
import { ReactComponent as AddMarksIcon } from "../../../images/examimage/addmarks.svg";
import { ReactComponent as DashboardIcon } from "../../../images/examimage/dashboard.svg";
import { ReactComponent as ResultIcon } from "../../../images/examimage/result.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { ToastContainer, toast } from "react-toastify";

function ViewExam() {
  const classes = useStyles();

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [exams, setExams] = useState([]);
  const [visiblePins, setVisiblePins] = useState({});
  const [visiblePinRowId, setVisiblePinRowId] = useState(null);

  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // const handleButtonClickQuestion = (type) => {
  //   navigate(`/admin/${type}`);
  // };

  const handleButtonClickQuestion = (type, rowId, score) => {
    navigate(`/admin/${type}/${rowId}`, { state: score });
  };

  // const togglePinVisibility = (rowId) => {
  //   setVisiblePins((prev) => ({
  //     ...prev,
  //     [rowId]: !prev[rowId],
  //   }));
  // };

  const togglePinVisibility = (rowId) => {
    setVisiblePinRowId((prev) => (prev === rowId ? null : rowId));
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editexam") {
      navigate(`/admin/editexam/${rowId}`);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setOnPage(0);
    setPage(0);
  };

  const fetchData = async (pageNumber, size, search, date) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const params = {
        page: pageNumber + 1,
        limit: size,
      };

      if (search) params.search = search;
      if (date) params.date = date;

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam`,
        {
          params,
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      setExams(response.data.exam);
      setRowCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  useEffect(() => {
    if (
      onPage !== undefined &&
      pageSize !== undefined &&
      searchQuery !== undefined
    ) {
      fetchData(onPage, pageSize, searchQuery, dateFilter);
    }
  }, [onPage, pageSize, searchQuery, dateFilter]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage);
  };

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      console.log("Exam deleted:", response.data);
      fetchData();
      handleClose();
      toast.success("Exam deleted successfully");
      const updateddatatata = exams.filter((data) => data.id !== rowId);
      setExams(updateddatatata);
    } catch (error) {
      toast.error("Exam is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const data = {
      exam: {
        active_status: newStatus,
        id: iddd,
      },
    };
    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/status`, data, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      })
      .then((response) => {
        console.log("Exam status changed successfully", response);
        fetchData(onPage, pageSize, searchQuery);
        toast.success("Exam status changed successfully");
        handleClose();
      })
      .catch((error) => {
        console.error("Error changed Exam status:", error);
        toast.error("Exam status is not changed");
      });
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const style = [
    {
      style: "viewtable",
      height: "maxh67",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 20,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "exam_name",
      headerName: "Exam Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 300,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      valueGetter: (params) =>
        params.value.charAt(0).toUpperCase() + params.value.slice(1),
    },
    {
      field: "date",
      headerName: "Date",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "template_layout",
      headerName: "Template Layout",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,

      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (params) => (
        <span style={{ textTransform: "uppercase" }}>{params.value}</span>
      ),
    },
    {
      field: "exam_set",
      headerName: "Exam Set",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "action",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 250,
      autoPageSize: false,
      renderCell: (params) => {
        // {console.log("params",params)}

        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              onClick={() => {
                handleButtonClickQuestion(
                  "addmarks",
                  params.row.id,
                  params.row.total_score,
                );
              }}
            >
              <LightTooltip title="Add Answer">
                <AddMarksIcon />
              </LightTooltip>
            </IconButton>

            <IconButton
              onClick={() => {
                handleButtonClickQuestion("examresult", params.row.id);
              }}
            >
              <LightTooltip title="Result">
                <ResultIcon />
              </LightTooltip>
            </IconButton>
          </div>
        );
      },
    },
    {
      field: "active_status",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}
              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status,
                    );
                  }}
                >
                  <LightTooltip title="status">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleButtonClick("editexam", cellValues.row.id);
                  }}
                >
                  <LightTooltip title="edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => deleteDataOfRow(cellValues.row.id)}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    const startIndex = onPage * pageSize;

    const filteredExams = exams.filter((d) => {
      const matchesName =
        !searchQuery ||
        d.exam_name?.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesDate = !dateFilter || d.date === dateFilter;
      return matchesName && matchesDate;
    });

    const mappedRows = filteredExams.map((d) => ({
      id: d.id || "N/A",
      exam_name: d.exam_name || "N/A",
      date: d.date || "N/A",
      template_layout: d.template_layout || "N/A",
      exam_set: d.sat || "N/A",
      active_status: d.active_status || "N/A",
    }));

    const finalRows = mappedRows.map((row, index) => ({
      ...row,
      srno: startIndex + index + 1,
    }));

    setRows(finalRows);
  }, [exams, searchQuery, dateFilter, onPage, pageSize]);

  // const rows = exams.map((d) => ({
  //   id: d.id || "N/A",
  //   exam_name: d.exam_name || "N/A",
  //   date: d.date || "N/A",
  //   template_layout: d.template_layout || "N/A",
  //   exam_set: d.sat || "N/A",
  //   active_status: d.active_status || "N/A",
  // }));

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <div
          className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.gap10} ${classes.pt1} ${classes.pr1}`}
          style={{
            justifyContent: "end",
          }}
        >
          <div
            className={`${classes.dflex} ${classes.alignitemsend} ${classes.gap10}`}
          >
            <div className={`${classes.dflex} ${classes.flexdirectioncolumn}`}>
              <TextField
                type="date"
                variant="outlined"
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
                inputProps={{ max: "9999-12-31" }}
              />
            </div>
          </div>

          <div
            className={`${classes.dflex} ${classes.alignitemsend} ${classes.gap10}`}
          >
            <TextField
              className={`${classes.textcolorformlabel} ${classes.fontsize3}`}
              type="text"
              variant="outlined"
              placeholder="Search By Exam"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch(searchInput);
                }
              }}
            />
            <Button
              className={`${classes.custombtnblue}`}
              onClick={() => handleSearch(searchInput)}
              type="button"
            >
              Search
            </Button>
          </div>
        </div>
        <div
          className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.gap10} ${classes.pt1} ${classes.pb1}`}
        ></div>
        <TableView columns={columns} rows={rows} Heading={style} />
      </div>
    </>
  );
}
export default ViewExam;
